import Modal from '@components/Modal'
import {
  MigrationModalButtons,
  MigrationModalDisclaimer,
  MigrationModalHeading,
  MigrationModalWrapper,
} from './index.style'
import React, { useEffect, useState } from 'react'
import Button from '@components/Button'
import { TextBodySmall } from '@components/TextStyles'
import IconArrowUpRight from '@svgs/IconArrowUpRight'
import Spacer from '@components/Spacer'
import { setModalShown, useStore } from '@Store/index'

const data = [
  {
    url: 'offers',
    title: 'EXCITING CHANGES ON THE HORIZON',
    text: 'The Loyal To You Always Offers section has transitioned to Featured Offers within CruisingPower for a more streamlined and enhanced experience.',
    ctas: [
      {
        link: 'https://secure.cruisingpower.com/promotion/featured-offers?brand=R',
        text: 'Visit Featured Offers on CruisingPower',
      },
    ],
  },
  {
    url: 'training',
    title: 'EXCITING CHANGES ON THE HORIZON',
    text: 'The Loyal To You Always Training section has transitioned to Royal Caribbean University within CruisingPower for a more streamlined and enhanced experience.',
    ctas: [
      {
        link: 'https://secure.cruisingpower.com/redirect?toolCode=ROYAL-TRAINING-CERTIFICATION',
        text: 'Visit Royal Caribbean University',
      },
    ],
  },
]

const MigrationModal = ({ location }) => {
  const [open, setOpen] = useState(false)

  // List of urls to hide the modal on
  const urls = ['offers', 'training']

  // Only show the modal if the current page matches one of the urls.

  useEffect(() => {
    setOpen(urls.some(url => location.pathname.includes(url)))
  }, [location.pathname])

  return (
    <Modal isOpen={open} ariaLabel="Title">
      <MigrationModalWrapper>
        <MigrationModalHeading>
          {data.find(item => location.pathname.includes(item.url))?.title}
        </MigrationModalHeading>
        <Spacer size={20} />
        <TextBodySmall>
          {data.find(item => location.pathname.includes(item.url))?.text}
        </TextBodySmall>
        <Spacer size={32} />
        <MigrationModalButtons>
          <Button
            variant="secondary"
            to={'/'}
            type="internalLink"
            onClick={() => {
              setTimeout(() => {
                setOpen(false)
              }, 100)
            }}
          >
            Back to Loyal To You Always
          </Button>
          <Button
            type="externalLink"
            href={
              data.find(item => location.pathname.includes(item.url))?.ctas[0]
                ?.link
            }
            variant="secondary"
            iconRight={<IconArrowUpRight />}
          >
            {
              data.find(item => location.pathname.includes(item.url))?.ctas[0]
                ?.text
            }
          </Button>
        </MigrationModalButtons>
        <Spacer size={32} />
        <MigrationModalDisclaimer>
          Be sure to allow popups for{' '}
          <a href="http://cruisingpower.com/">CruisingPower.com</a>.
        </MigrationModalDisclaimer>
      </MigrationModalWrapper>
    </Modal>
  )
}

export default MigrationModal
